import { TabsRootDataAttributes } from "./TabsRootDataAttributes.js";
export const tabsStateAttributesMapping = {
  tabActivationDirection: dir => ({
    [TabsRootDataAttributes.activationDirection]: dir
  })
};